import React from 'react'
import Box from '../UI/Box'
import { Color } from '../../interfaces/designSystem'
import Flex from '../UI/Flex'
import styled from 'styled-components'
import { Avatar, Dropdown } from 'antd'
import { AiFillCreditCard, AiOutlineUser } from 'react-icons/ai'
import { CgLogOut, CgProfile } from 'react-icons/cg'
import { createBillingPortalSession, logout, useGetProfile } from '@api/users'
import routes from '../../routes'
import { useRouter } from 'next/navigation'
import Grid from '../UI/Grid'
import { useFetch } from '@utils/reactQuery'
import { UserInterface } from '@interfaces/auth'
import { GrContact } from 'react-icons/gr'
import { FaCrown } from 'react-icons/fa'
import IconButton from '@ui/IconButton'
import TrialHeaderBanner from '@components/TrialHeaderBanner/TrialHeaderBanner'
import { TbBulb } from 'react-icons/tb'
import PromoHeaderBanner from '@components/PromoHeaderBanner/PromoHeaderBanner'

const Wrap = styled(Box)`
  flex-shrink: 0;
  padding: 8px;
`

const Logo = styled.a`
  display: block;
  background: url('/img/logo.svg') no-repeat center center / contain;
  width: 110px;
  height: 40px;

  @media (max-width: 405px) {
    opacity: 0;
    visibility: hidden;
  }

  @media (max-width: 480px) {
    background: url('/img/logo-compact.svg') no-repeat center center / contain;
    width: 40px;
    height: 40px;
  }
`

type Props = {
  children?: React.ReactNode
  hideUser?: boolean
  onlyLogout?: boolean
}

const Header = ({ children, hideUser, onlyLogout }: Props) => {
  const { data: profile } = useGetProfile()
  const { data } = useFetch<UserInterface>(hideUser ? null : routes.api.user.me)

  const router = useRouter()

  const items: {
    label: string
    key: string
    icon: React.ReactNode
    onClick: () => Promise<void>
  }[] = []

  if (!onlyLogout) {
    items.push({
      label: 'Profile',
      key: 'profile',
      icon: <CgProfile />,
      onClick: async () => {
        router.push(routes.privateRoutes.profile)
      },
    })

    // items.push({
    //   label: 'Manage subscription',
    //   key: 'subscription',
    //   icon: <AiFillCreditCard />,
    //   onClick: async () => {
    //     const resp = await createBillingPortalSession()
    //     router.push(resp.data.url)
    //   },
    // })
  }

  items.push({
    label: 'Give us a feedback',
    key: 'feedback',
    icon: <TbBulb />,
    onClick: async () => {
      window.open(routes.external.feedback, '_blank')
    },
  })

  items.push({
    label: 'Contact us',
    key: 'contact',
    icon: <GrContact />,
    onClick: async () => {
      router.push(routes.publicRoutes.contact)
    },
  })

  items.push({
    label: 'Logout',
    key: 'logout',
    icon: <CgLogOut />,
    onClick: async () => {
      await logout()
      window.location.href = routes.guestRoutes.login
    },
  })

  return (
    <>
      <Wrap bg={Color.DarkGrey}>
        <Flex justifyContent="space-between" alignItems="center" height="100%">
          <Logo href={routes.publicRoutes.home} />
          <Grid gap={16} flow="column" alignItems="center">
            <Box>{children}</Box>
            {profile?.plan === 'free' && !onlyLogout && (
              <IconButton
                type="default"
                ghost
                icon={FaCrown}
                iconSize={14}
                onClick={async () => {
                  const resp = await createBillingPortalSession('pro')
                  router.push(resp.data.url)
                }}
              >
                Upgrade
              </IconButton>
            )}
            {data && (
              <Dropdown
                trigger={['click']}
                menu={{
                  items,
                }}
              >
                <Avatar
                  size={32}
                  style={{
                    backgroundColor: Color.Grey_50,
                    color: Color.White,
                    cursor: 'pointer',
                  }}
                  src={data.picture}
                  // src="https://media.licdn.com/dms/image/C4D03AQEhOeCxBeA3rw/profile-displayphoto-shrink_800_800/0/1641831806031?e=1703116800&v=beta&t=mgqnc-tJhGMXV4lvIJ5HA-6eyqbZ8ozPcimKeRERszM"
                  icon={<AiOutlineUser />}
                />
              </Dropdown>
            )}
          </Grid>
        </Flex>
      </Wrap>
      {!onlyLogout && <TrialHeaderBanner />}
      {!onlyLogout && <PromoHeaderBanner />}
    </>
  )
}

export default Header
